module.exports = __webpack_public_path__ + "img/fa-5@3x.fee2932a.png";